<script>
import { mapGetters, mapState } from 'vuex';
	export default {
		name: "MenuSection",
		props: {
			collapsed: {
				type: Boolean,
				required: false,
				default: false
			},
			title: {
				type: String,
				required: true
			},
			icon: {
				type: String,
				required: false,
				default: ""
			},
			pill: {
				type: [String, Number],
				required: false,
				default: ""
			},
			additionalTagIA: {
				type: Boolean,
				required: false,
				default: false
			}
		},
		data() {
			return {
				visible: false
			};
		},
		computed: {
			...mapGetters(['hasAccessToCurrencies']),
      ...mapState({
        is_superadmin: state => state.home.is_superadmin,
      }),
			modalName() {
				let name = "";
				switch (this.title) {
					case "Devises":
						name = "billing_currencies"
						break;

					case "Langues":
						name = "billing_langs"
						break;
				
					default:
						break;
				}
				return name;
			},
			hasAccessToPremiumFeature() {
				const premiumTitles = ["Devises", "Langues"];
				return premiumTitles.find(title => this.title === title) !== undefined && !this.hasAccessToCurrencies ? false : true;
			}
		},
		watch: {
			// if collapsed is updated, update the visibility status of the item
			collapsed(newValue) {
				this.visible = newValue;
			}
		},
		mounted() {
			this.visible = this.collapsed;
		},
		methods: {
			call_premium_feature() {
				this.dispatchEvent({
					modalName: this.modalName,
					source: "billing",
					action: "premium_feature",
					data: {
						modalName: this.modalName
					}
				});
			},
			openMenuDetails() {
				if (this.hasAccessToPremiumFeature || this.is_superadmin )
					this.visible = !this.visible;
				else
					this.call_premium_feature();
				
			}
		}
	};
</script>

<template lang="html">
	<b-card no-body class="floating-menu-tab">
		<b-card-header
			header-tag="header"
			class="floating-menu-tab__header"
			:class="{ 'floating-menu-tab__header--open': visible }"
			role="tab"
		>
			<b-button
				block
				squared
				variant="light"
				class="floating-menu-tab__control"
				@click="openMenuDetails()"
			>
				<b-row>
					<b-col cols="10">
						<span v-if="additionalTagIA" class="tagIAMenu">
							IA
						</span>
						<span v-else>
							<b-icon v-if="icon !== ''" :icon="icon" />
						</span>

						{{ title }}

						<b-badge v-if="pill !== ''" href="#" variant="danger">
							{{ pill }}
						</b-badge>
					</b-col>
					<b-col cols="2">
						<span 
							v-if="!hasAccessToPremiumFeature"
							align-h="start"
						>
							<b-icon icon="star-fill" variant="warning" />
						</span>
					</b-col>
				</b-row>
			</b-button>
		</b-card-header>
		<b-collapse v-model="visible" role="tabpanel">
			<b-card-body>
				<slot />
			</b-card-body>
		</b-collapse>
	</b-card>
</template>

<style scoped lang="scss">
	.floating-menu-tab {
		border: none;
		border-radius: 0;

		&:last-of-type,
		&:last-of-type &__header:not(#{&}--open) &__control {
			transition: border-radius 0ms 340ms linear;
		}
		&:last-of-type &__header#{&}__header--open &__control {
			transition: border-radius 0ms 10ms linear;
		}

		&__header {
			padding: 0;
			border: none;
			border-radius: 5px;
			background: #ebeff2;
		}

		&__control {
			text-align: left;
			font-size: 15px;

			&:focus,
			&:active,
			&:active#{&}:active {
				box-shadow: none;
			}
		}
	}

	.tagIAMenu {
		background-color: rgb(161, 131, 191);
		color: var(--white);
		padding: 4px 6px;
		font-size: 12px !important;
		border-radius: 2px;
		margin-right: 6px;
		display: inline-block;
	}
</style>
